import React from "react";
import RiskFreeBetOffersGuide from "../Components/Guides/RiskFreeBetOffersGuide.jsx";
import ExtraPlaceGuide from "../Components/Guides/ExtraPlaceGuide.jsx";
import MatchedBettingGuide from "../Components/Guides/MatchedBettingGuide.jsx";
import FreeBetsGuide from "../Components/Guides/FreeBetsGuide.jsx";
import HowToReadOddsGuide from "../Components/Guides/HowToReadOddsGuide.jsx";
import BettingExchangeGuide from "../Components/Guides/BettingExchangeGuide.jsx";
import MatchedBettingRiskFreeGuide from "../Components/Guides/MatchedBettingRiskFreeGuide.jsx";
// import OddsMonkeyGuide from "../Components/Guides/OddsMonkeyGuide.jsx";
import OddsMonkeyGuideSimple from "../Components/Guides/OddsMonkeyGuideSimple.jsx";
import AccaBetsGuide from "../Components/Guides/AccaBetsGuide.jsx";

import LayBetBuildersGuide from "../Components/Guides/LayBetBuildersGuide.jsx";

import LayAccaSmarketsGuide from "../Components/Guides/LayAccaSmarketsGuide.jsx";

import ScamGuide from "../Components/Guides/ScamGuide.jsx";
import FreeBetValueGuide from "../Components/Guides/FreeBetValueGuide.jsx";
import FreeBetHighOddsGuide from "../Components/Guides/FreeBetHighOddsGuide.jsx";
import PriceBoostsGuide from "../Components/Guides/PriceBoostsGuide.jsx";

import HowToLayABet from "../Components/Guides/HowToLayABet.jsx";
import HorseRefundGuide from "../Components/Guides/HorseRefundGuide.jsx";
import EquivalentBoostedOddsGuide from "../Components/Guides/EquivalentBoostedOddsGuide.jsx";

import HowMuchMoneyGuide from "../Components/Guides/HowMuchMoneyGuide.jsx";
import DutchingGuide from "../Components/Guides/DutchingGuide.jsx";
import ArbingGuide from "../Components/Guides/ArbingGuide.jsx";


import { Layers, Info,  Percent, Repeat, MessageCircleWarning, Calculator, AlertTriangle, Tally4, Tally5, BadgePoundSterling, Zap, Rocket } from "lucide-react"; // Repeat icon for exchange
import { GiCancel, GiHorseHead } from "react-icons/gi";
import { RiFireLine } from "react-icons/ri";
import { AiFillPlusCircle } from "react-icons/ai";
import { FaDiceD20 } from "react-icons/fa";
import { GrMoney } from "react-icons/gr";
import { PiCirclesThreeLight } from "react-icons/pi";



const now = new Date();

const monthNames = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const month = monthNames[now.getMonth()];
const year = now.getFullYear();

const guidesConfig = {
  matchedBettingGuide: {
    title: "A Better Matched Betting Guide for Absolute Beginners",
    route: "/guides/matched-betting-guide",
    component: MatchedBettingGuide,
    seo: {
      title: `The Complete Matched Betting Guide For Beginners (${month} ${year})`,
      description:
        "A simple matched betting guide for absolute beginners, written for humans. Learn step-by-step how matched betting works, and how to profit from bookmaker free bets.",
    },
    sidebar: {
      category: "Matched Betting", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <Rocket size={20} />, // a Lucide icon
      label: "Matched Betting Guide", // Brief user friendly label
      sub: "",
    },
    category: ["intro"], // "intro" "basic" "inter" "advanced"
    label: "Complete Matched Betting Guide", // abridged title
    similar: ["LayStakeCalculator", "OddsConverter", "MatchPickerCalculator"], // use these values
    similarGuides: ["HowToReadOddsGuide","BettingExchangeGuide","OddsMonkeyGuideSimple"], // use these values
    highlight: true, // usually false by default
    author: 1, // 1 default
    level: 1  // 1 default
  },

  layStakeGuide: {
    title: "How to Lay a Bet",
    route: "/guides/lay-bet-guide",
    component: HowToLayABet,
    seo: {
      title: "How to Lay Bets | Matched Betting Explained",
      description: "Master matched betting by learning how to lay a bet step‑by‑step. Includes worked examples, practical tips, and common mistakes to avoid.",
    },
    sidebar: {
      category: "Matched Betting", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <GiCancel size={20} />,
      label: "How to Lay Bets",
      sub: "",
    },
    category: ["intro"], // "intro" "basic" "inter" "advanced"
    label: "How to Lay Bets",
    similar: ["LayStakeCalculator", "OddsConverter", "MatchPickerCalculator"],
    similarGuides: ["matchedBettingGuide","FreeBetsGuide","HowToReadOddsGuide"],
    highlight: false,
    author: 1,
    level: 1

  },
  freeBetsGuide: {
    title: "How to Profit from Free Bets",
    route: "/guides/free-bets-guide",
    component: FreeBetsGuide,
    seo: {
      title: `The Complete Free Bet Guide | Matched Betting Explained`,
      description:
        "Learn how to profit from free bet offers using matched betting techniques with our comprehensive guide. Covers qualifying bets, free bet use, practical examples, and more.",
    },
    sidebar: {
      category: "Basic Strategies", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <BadgePoundSterling size={20} />,
      label: "Free Bets Offers",
      sub: "",
    },
    category: ["basic"], // "intro" "basic" "inter" "advanced"
    label: "Free Bet Offers",
    similar: ["LayStakeCalculator", "OddsConverter", "MatchPickerCalculator"],
    similarGuides: ["matchedBettingGuide","RiskFreeBetOffersGuide","LayStakeGuide"],
    highlight: false,
    author: 1,
    level: 1

  },
  riskFreeBetOffersGuide: {
    title: "The Complete Guide to Risk-Free Bet Offers",
    route: "/guides/risk-free-bet-offers-guide",
    component: RiskFreeBetOffersGuide,
    seo: {
      title: "The Complete Risk-Free Bet Guide | Matched Betting Explained",
      description:
        "Learn about risk free bet offers, how they work, and how to maximise your matched betting profits using our risk-free bet calculator.",
    },
    sidebar: {
      category: "Basic Strategies", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <Info size={20} />,
      label: "Risk Free Bet Offers",
      sub: "",
    },
    category: ["basic"], // "intro" "basic" "inter" "advanced"
    label: "Risk Free Bet Offers",
    similar: ["RiskFreeCalculator", "RiskFreeEBOCalculator", "LayStakeCalculator"],
    similarGuides: ["matchedBettingGuide","FreeBetsGuide","LayStakeGuide"],
    priority: 1,
    highlight: false,
    author: 2,
    level: 2

  },
  accaBetsGuide: {
    title: "The Complete Accumulator Bets Guide",
    route: "/guides/acca-bets-guide",
    component: AccaBetsGuide,
    seo: {
      title: `The Complete Acca Bets Guide | Matched Betting Explained`,
      description:
        "Learn about accumulator bets (accas, or multiples) in matched betting, including sequential lay and lock in strategies, practical examples, and key tips to maximise your profit.",
    },
    sidebar: {
      category: "Basic Strategies", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <Tally4 size={20} />,
      label: "Accumulator Offers",
      sub: "",
    },
    keywords: {
      primary: ["acca", "what is acca", "what is accumulator"],
      secondary: []
    },
    category: ["basic"], // "intro" "basic" "inter" "advanced"
    label: "Accumulator Offers",
    similar: ["AccaPickerCalculator", "LayStakeCalculator", "MatchPickerCalculator"],
    similarGuides: ["LayAccaSmarketsGuide","LayBetBuildersGuide","OddsMonkeyGuideSimple"],
    highlight: false,
    author: 4,
    level: 2
  },
  layAccaSmarketsGuide: {
    title: "How to Lay an Acca on Smarkets",
    route: "/guides/how-to-lay-accumulators-on-smarkets-guide",
    component: LayAccaSmarketsGuide,
    seo: {
      title: `How to Lay an Acca on Smarkets | Matched Betting Explained`,
      description:
        "The simplest guide on the net on how to build and lay an accumulator bet on Smarkets. An accumulators guide for matched betting.",
    },
    sidebar: {
      category: "Basic Strategies", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <Tally5 size={20} />,
      label: "How to Lay an Acca on Smarkets",
      sub: "",
    },
    category: ["basic"], // "intro" "basic" "inter" "advanced"
    label: "How to Lay an Acca on Smarkets",
    similar: ["AccaPickerCalculator", "LayStakeCalculator", "MatchPickerCalculator"],
    similarGuides: ["AccaBetsGuide","LayBetBuildersGuide","OddsMonkeyGuideSimple"],
    highlight: true,
    author: 4,
    level: 2
  },
  layBetBuildersGuide: {
    title: "A Better Guide on How to Lay Bet Builders",
    route: "/guides/how-to-lay-bet-builders",
    component: LayBetBuildersGuide,
    seo: {
      title: `A Better Guide on How to Lay Bet Builders (${month} ${year})`,
      description:
        "Struggling to lay your Bet Builder bets on Smarkets or Betfair? This guide shows you how to match bet builder combos using exchange markets like a pro.",
    },
    sidebar: {
      category: "Next Steps", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <Layers size={20} />,
      label: "How to Lay Bet Builders",
      sub: "",
    },
    keywords: {
      primary: ["what is a bet builder"],
      secondary: []
    },
    category: ["inter"], // "intro" "basic" "inter" "advanced"
    label: "How to Lay Bet Builders",
    similar: ["LayStakeCalculator", "AccaPickerCalculator", "MatchPickerCalculator"],
    similarGuides: ["AccaBetsGuide","LayAccaSmarketsGuide","OddsMonkeyGuideSimple"],
    highlight: false,
    author: 4,
    level: 3
  },
  ExtraPlaceGuide: {
    title: "The Complete Guide to Targeting Extra Places",
    route: "/guides/extra-place-offers-guide",
    component: ExtraPlaceGuide,
    seo: {
      title: "The Extra Place Offers Guide | Matched Betting Explained",
      description:
        "Learn how extra place offers work, and maximise profits from matched betting using our extra place calculator.",
    },
    sidebar: {
      category: "Advanced Strategies", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <AiFillPlusCircle />,
      label: "Extra Place Offers",
      sub: "",
    },
    keywords: {
      primary: ["E/W", "EW"],
      secondary: ["horse racing", "golf"]
    },
    category: ["advanced"], // "intro" "basic" "inter" "advanced"
    label: "Extra Place Offers",
    similar: ["ExtraPlaceMatcherCalculator", "OddsBoostCalculator", "RiskFreeEBOCalculator"],
    similarGuides: ["LayBetBuildersGuide","LayAccaSmarketsGuide","OddsMonkeyGuideSimple"],
    highlight: false,
    author: 4,
    level: 4

  },
  howToReadOddsGuide: {
    title: "How to Read Odds For Matched Betting",
    route: "/guides/how-to-read-odds",
    component: HowToReadOddsGuide,
    seo: {
      title: `How to Read Odds | Matched Betting Explained`,
      description:
        "Learn how to read fractional, decimal and American odds and calculate implied probability in matched betting with this beginner-friendly guide.",
    },
    sidebar: {
      category: "Matched Betting", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <Percent size={20} />,
      label: "How to Read Odds",
      sub: "",
    },
    keywords: {
      primary: ["odds convert", "convert odds"],
      secondary: ["fractional odds", "decimal odds", "american odds"]
    },
    category: ["intro"], // "intro" "basic" "inter" "advanced"
    label: "How to Read Odds",
    similar: ["OddsConverter", "LayStakeCalculator", "MatchPickerCalculator"],
    similarGuides: ["matchedBettingGuide","BettingExchangeGuide","FreeBetsGuide"],
    highlight: false,
    author: 4,
    level: 1

  },
  bettingExchangeGuide: {
    title: "What is a Betting Exchange?",
    route: "/guides/betting-exchange-guide",
    component: BettingExchangeGuide,
    seo: {
      title: `What is a Betting Exchange? | Matched Betting Explained`,
      description:
        "Understand how betting exchanges work, including back and lay bets, liability, and liquidity. Learn which exchanges to use for matched betting.",
    },
    sidebar: {
      category: "Matched Betting", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <Repeat size={20} />,
      label: "What is an Exchange?",
      sub: "",
    },
    keywords: {
      primary: ["smarkets", "betfair", "betdaq", "betconnect", "matchbook", "what is an exchange"],
      secondary: []
    },
    category: ["intro"], // "intro" "basic" "inter" "advanced"
    label: "What is a Betting Exchange?",
    similar: ["LayStakeCalculator", "OddsConverter", "MatchPickerCalculator"],
    similarGuides: ["matchedBettingGuide","HowToReadOddsGuide","FreeBetsGuide"],
    highlight: false,
    author: 1,
    level: 1

  },
  OddsMonkeyGuideSimple: {
    title: "The OddsMonkey Oddsmatcher",
    route: "/guides/oddsmonkey-guide",
    component: OddsMonkeyGuideSimple,
    seo: {
      title: `All About The OddsMonkey Oddsmatcher`,
      description:
        "Discover why OddsMonkey is a must-have tool for matched betting. Dive into the core OddsMatcher, explore practical examples, definitions, and tips to maximise your profits.",
    },
    sidebar: {
      category: "Matched Betting", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <Calculator size={20} />,
      label: "OddsMonkey Guide",
      sub: "",
    },
    keywords: {
      primary: ["tools", "matched betting platform", "matched betting tools", "profit tracker", "odds matcher", "match finder", "bet finder", "offers"],
      secondary: []
    },
    category: ["intro"], // "intro" "basic" "inter" "advanced"
    label: "OddsMonkey Guide",
    similar: ["LayStakeCalculator", "OddsConverter", "MatchPickerCalculator"],
    similarGuides: ["matchedBettingGuide","FreeBetsGuide","LayStakeGuide"],
    highlight: true,
    author: 1,
    level: 1
  },
  // oddsMonkeyGuide: {
  //   route: "/guides/oddsmonkey-worth-it",
  //   component: OddsMonkeyGuide,
  //   seo: {
  //     title: `Is OddsMonkey still worth it?`,
  //     description:
  //       "Discover why OddsMonkey is a must-have tool for matched betting. Dive into the core OddsMatcher, explore practical examples, definitions, and tips to maximise your profits.",
  //   },
  //   sidebar: {
  //     category: "Betting Guides",
  //     icon: <Calculator size={20} />,
  //     label: "OddsMonkey Guide",
  //     sub: "",
  //   },
  //   category: ["matched betting"],
  //   label: "Complete OddsMonkey Guide",
  //similar: ["LayStakeCalculator", "OddsConverter", "MatchPickerCalculator"],
   // similarGuides: ["matchedBettingGuide","FreeBetsGuide","LayStakeGuide"],//   
  //highlight: true,
  // },
  matchedBettingRiskFreeGuide: {
    title: "Is Matched Betting Risk-Free?",
    route: "/guides/matched-betting-risk-free-guide",
    component: MatchedBettingRiskFreeGuide,
    seo: {
      title: `Is matched betting risk-free?`,
      description:
        "People love to say matched betting is risk-free, but it isn't. Let's talk about it.",
    },
    sidebar: {
      category: "Matched Betting", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <MessageCircleWarning size={20} />,
      label: "Is Matched Betting Risk-Free?",
      sub: "",
    },
    category: ["intro"], // "intro" "basic" "inter" "advanced"
    label: "Is Matched Betting Risk-Free?",
    similar: ["riskFreeBetCalculator", "OddsMonkeyGuideSimple", "accaPickerCalculator"],
    similarGuides: ["matchedBettingGuide","FreeBetsGuide","HowToReadOddsGuide"],
    highlight: false,
    author: 1,
    level: 1
  },

  scamGuide: {
    title: "Is Matched Betting a Scam? An Honest Look at All the Downsides",
    route: "/guides/is-matched-betting-a-scam",
    component: ScamGuide,
    seo: {
      title: `Is Matched Betting A Scam? No... But Here's The Catch`,
      description:
        "The short answer is no, matched betting isn't a scam. But there's still a few catches. Let's go through them and give them an honest appraisal.",
    },
    sidebar: {
      category: "Matched Betting", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <AlertTriangle size={20} />,
      label: "Is Matched Betting A Scam?",
      sub: "",
    },
    category: ["intro"], // "intro" "basic" "inter" "advanced"
    label: "Is Matched Betting A Scam?",
    similar: ["riskFreeBetCalculator", "OddsMonkeyGuideSimple", "accaPickerCalculator"],
    similarGuides: ["matchedBettingGuide","FreeBetsGuide","HowToReadOddsGuide"],
    highlight: false,
    author: 2,
    level: 0,
    display: {
      guides: false,
      sidebar: false
    }
  },
  freeBetValueGuide: {
    title: "Why Do You Only Keep 70–80% of a Free Bet’s Value?",
    route: "/guides/free-bet-value-guide",
    component: FreeBetValueGuide,
    seo: {
      title: "Why Free Bets Only Return 70–80% Profit | Matched Betting Explained",
      description:
        "Discover why you only keep 70–80% of a free bet’s value when matched betting. Includes stake rules, examples, calculator tips, and how to maximise profits.",
    },
    sidebar: {
      category: "Matched Betting", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <BadgePoundSterling size={20} />,
      label: "Why We Get 70-80% From Free Bets",
      sub: "",
    },
    category: ["intro"], // "intro" "basic" "inter" "advanced"
    label: "Why We Get 70-80% From Free Bets",
    similar: ["freeBetCalculator", "LayStakeCalculator", "MatchPickerCalculator"],
    similarGuides: ["matchedBettingGuide", "FreeBetHighOddsGuide", "LayStakeGuide"],
    highlight: false,
    author: 1,
    level: 1
  },
  FreeBetHighOddsGuide: {
    title: "Why We Use Free Bets on Higher Odds",
    route: "/guides/free-bet-high-odds-guide",
    component: FreeBetHighOddsGuide,
    seo: {
      title: "Why We Use Free Bets on Higher Odds | Matched Betting Explained",
      description:
        "Learn why we choose higher odds to lock in profit from free bets when matched betting. Get more profit from your free bets when we choose selections with odds 5.0+.",
    },
    sidebar: {
      category: "Matched Betting", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <BadgePoundSterling size={20} />,
      label: "Why We Use Free Bets on Higher Odds",
      sub: "",
    },
    keywords: {
      primary: [],
      secondary: ["free bets", "lay", "offers"]
    },
    category: ["intro"], // "intro" "basic" "inter" "advanced"
    label: "Why We Use Free Bets on Higher Odds",
    similar: ["freeBetCalculator", "LayStakeCalculator", "MatchPickerCalculator"],
    similarGuides: ["matchedBettingGuide", "freeBetValueGuide", "LayStakeGuide"],
    highlight: false,
    author: 1,
    level: 1
  },
  priceBoostsGuide: {
    title: "The Complete Guide to Price Boosts",
    route: "/guides/price-boosts",
    component: PriceBoostsGuide,
    seo: {
      title: `The Price Boosts Guide | Matched Betting Guide`,
      description:
        "Discover how to profit from price boosts in matched betting using our comprehensive guide. Explore step-by-step strategies, practical examples, and essential tips to unlock risk-free returns.",
    },
    sidebar: {
      category: "Basic Strategies", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <RiFireLine />,
      label: "Price Boosts",
      sub: "",
    },
    category: ["basic"], // "intro" "basic" "inter" "advanced"
    label: "Price Boosts",
    similar: ["LayStakeCalculator", "OddsConverter", "CTACalculator"],
    similarGuides: ["MatchedBettingGuide", "RiskFreeBetOffersGuide", "FreeBetsGuide"],
    highlight: false,
    author: 1,
    level: 2
  },

  horseRefundGuide: {
    title: "The Complete Guide to Horse Racing Refund Offers",
    route: "/guides/horse-refund-guide",
    component: HorseRefundGuide,
    seo: {
      title: `The Horse Racing Refund Offers Guide | Matched Betting Explained`,
      description:
        "Learn how to turn horse racing refund offers, or money back offers, into reliable matched betting profits. Covers offer types, step‑by‑step examples, practical tips, advanced strategies, and how to find offers.",
    },
    sidebar: {
      category: "Next Steps", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <GiHorseHead />
      ,
      label: "Horse Racing Refunds",
      sub: "",
    },
    category: ["inter"], // "intro" "basic" "inter" "advanced"
    label: "Horse Racing Refund Offers",
    similar: [
      "refundCalculator",
      "extraPlaceMatcherCalculator",
      "MatchPickerCalculator"
    ],
    similarGuides: [
      "ExtraPlaceGuide",
      "FreeBetsGuide",
      "RiskFreeBetOffersGuide"
    ],
    highlight: false,
    author: 4,
    level: 3
  },
  
  equivalentBoostedOddsGuide: {
    title: "Advantage Play for Risk‑Free Bets: The Equivalent Boosted Odds Method",
    route: "/guides/ebo-method-advantage-play",
    component: EquivalentBoostedOddsGuide,
    seo: {
      title: `Advantage Play for Risk‑Free Bets: EBO Method`,
      description:
        "Learn to calculate Equivalent Boosted Odds (EBO) and unlock more value from risk‑free bets. Step‑by‑step guide, clear examples and pro tips for matched bettors.",
    },
    sidebar: {
      category: "Advanced Strategies", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <FaDiceD20 />,
      label: "Risk-Free Bet Advantage Play",
      sub: "",
    },
    category: ["advanced"], // "intro" "basic" "inter" "advanced"
    label: "Risk-Free Bet Advantage Play",
    similar: [
      "RiskFreeEBOCalculator",
      "OddsConverter",
      "LayStakeCalculator"
    ],
    similarGuides: [
      "RiskFreeBetOffersGuide",
      "RiskFreeCalculator",
      "LayBetBuildersGuide"
    ],
    highlight: false,
    author: 4,
    level: 4
  },
  howMuchMoneyGuide: {
    title: "How Much Money Can You Realistically Make Matched Betting?",
    route: "/guides/how-much-money-matched-betting",
    component: HowMuchMoneyGuide,
    seo: {
      title: `How Much Money Can You Realistically Make Matched Betting? (${month} ${year})`,
      description:
        "Discover realistic earning potential for matched betting: signup offers, reloads, advanced strategies, and hourly rates in a clear, impartial guide.",
    },
    sidebar: {
      category: "Matched Betting", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <GrMoney size={20} />,
      label: "How Much Can You Earn?",
      sub: "",
    },
    category: ["intro"], // "intro" "basic" "inter" "advanced"
    label: "How Much Can You Earn?",
    similar: [
      "LayStakeCalculator",
      "OddsConverter",
      "MatchPickerCalculator"
    ],
    similarGuides: [
      "HowToReadOddsGuide",
      "BettingExchangeGuide",
      "OddsMonkeyGuideSimple"
    ],
    highlight: false,
    author: 2,
    level: 1
  },
  dutchingGuide: {
    title: "Dutching in Matched Betting",
    route: "/guides/dutching",
    component: DutchingGuide,
    seo: {
      title: `What is Dutching? Matched Betting Explained`,
      description:
        "What is dutching? Master dutching in matched betting with step-by-step examples, tips for finding dutch arbs, and practical advice to lock in consistent returns.",
    },
    sidebar: {
      category: "Next Steps", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <PiCirclesThreeLight size={20} />,
      label: "What is Dutching?",
      sub: "",
    },
    category: ["inter"], // "intro" "basic" "inter" "advanced"
    label: "What is Dutching?",
    similar: [
      "DutchingCalculator",
      "RefundCalculator",
      "ExtraPlaceMatcherCalculator"
    ],
    similarGuides: [
      "HorseRefundGuide",
      "ExtraPlaceGuide",
      "LayBetBuildersGuide"
    ],
    highlight: false,
    author: 1,
    level: 3
  },

  arbingGuide: {
    title: "What Is Arbing in Matched Betting?",
    route: "/guides/arbing",
    component: ArbingGuide,
    seo: {
      title: `What Is Arbing in Matched Betting?`,
      description:
        "Discover how to use arbitrage (arbing) within matched betting to lock in guaranteed profits. Includes formulas, worked examples, top tools and pro tips—while avoiding gubbing.",
    },
    sidebar: {
      category: "Advanced Strategies", // or "Basic Strategies" "Next Steps" "Advanced Strategies"
      icon: <Zap size={20} />,
      label: "What is Arbing?",
      sub: "",
    },
    category: ["advanced"], // "intro" "basic" "inter" "advanced"
    label: "What is Arbing?",
    similar: [
      "LayStakeCalculator",
      "OddsConverter",
      "MatchPickerCalculator",
    ],
    similarGuides: [
      "HowToReadOddsGuide",
      "BettingExchangeGuide",
      "OddsMonkeyGuideSimple",
    ],
    highlight: false,
    author: 1,
    level: 4,
  },
};



export default guidesConfig;
